import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Checkbox,
} from "@mui/material";
import {
  AddRounded,
  EditRounded,
  DeleteOutlineRounded,
  RestoreFromTrashRounded,
} from "@mui/icons-material";



// ---------------------------------------------------------------------------
// Tasks Panel
// ---------------------------------------------------------------------------
export default function TasksPanel({ projectId, tasks, onAdd, onToggle, onRename, onDelete, onClearDone }) {
  const [newTitle, setNewTitle] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");

  function submitNew() {
    const t = newTitle.trim();
    if (!t) return;
    onAdd({ title: t });
    setNewTitle("");
  }
  function startEdit(task) {
    setEditingId(task.id);
    setEditText(task.title);
  }
  function commitEdit() {
    const v = editText.trim();
    if (!v) return;

    setEditingId(null);
    setEditText("");
  }

  const doneCount = tasks.filter((t) => t.done).length;

  return (
    <Box>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ xs: "stretch", sm: "center" }} sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ flex: 1 }}>Tasks</Typography>
        <TextField size="small" placeholder="New task…" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submitNew()} sx={{ flex: 2 }} />
        <Button startIcon={<AddRounded />} variant="contained" onClick={submitNew}>Add</Button>
        <Button startIcon={<RestoreFromTrashRounded />} color="warning" onClick={onClearDone} disabled={doneCount === 0}>
          Clear done
        </Button>
      </Stack>

      <List>
        {tasks.map((t) => (
          <ListItem key={t.id} disableGutters secondaryAction={
            <Stack direction="row" spacing={0.5}>
              {editingId !== t.id && (
                <Tooltip title="Edit">
                  <IconButton size="small" onClick={() => startEdit(t)}>
                    <EditRounded fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Delete">
                <IconButton size="small" onClick={() => onDelete(t)}>
                  <DeleteOutlineRounded fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>
          }>
            <ListItemIcon>
              <Checkbox edge="start" checked={t.done} onChange={() => onToggle({ ...t, done: !t.done })} />
            </ListItemIcon>

            {editingId === t.id ? (
              <Stack direction="row" spacing={1} sx={{ flex: 1 }}>
                <TextField size="small" fullWidth value={editText} onChange={(e) => {
                  setEditText(e.target.value);

                }
                } onKeyDown={(e) => {
                  e.key === "Enter" &&
                  commitEdit();

                }
                } />
                <Button size="small" variant="contained" onClick={() => {
                  commitEdit();
                  onRename({ ...t, title: editText })
                }
                }>Save</Button>
              </Stack>
            ) : (
              <ListItemText primary={t.title} secondary={t.done ? "Done" : undefined} sx={{ textDecoration: t.done ? "line-through" : "none", opacity: t.done ? 0.6 : 1 }} />
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
